import { DurationInterface, DurationPeriod } from '@vendasta/sales-orders';

export const DEFAULT_CONTRACT_DURATION: DurationInterface = {
  value: 1,
  duration: DurationPeriod.YEAR,
};
